export default {
	privacy: 'Privacy Policy',
	beet: {
		credits: 'Website created by'
	},
	select: {
		field: 'Select a field'
	},
	moreDetails: 'More details',
	noResults: 'No result matched your criteria. You can subscribe to a job alert to receive a notification when a job offer opens.'
}
